import { configureStore } from "@reduxjs/toolkit";
import Globalslice from "./Globalslice"; // Adjust path as necessary

const store = configureStore({
    reducer: {
        Globalslice: Globalslice, 

    },
});

export default store;
